module.exports = __webpack_public_path__ + "img/ic_comment_red.4ffa7cde.svg";